module.exports = __webpack_public_path__ + "static/media/no-kpidata-range.7a312132.png";